//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/Expression.js";
import "../no/SelectTaggedObject.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"Alignment",0,"SelectTaggedObjectList",0],[0,"AttachmentSide",1,0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[1,"DepthOffset",0,"Expression",0],[0,"FillType",1,0],[1,"Height",0,"Expression",0],[0,"HeightType",1,0],[1,"OffsetDistance",0,"Expression",0],[0,"ReverseOffset",1,0],[1,"SelectObject",0,"SelectTaggedObject",0],[0,"StiffenerName",1,0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[0,"ThicknessDir",1,0]],[],[]];
SPLM.Features.StructureDesign.StiffenerBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.StiffenerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.StiffenerBuilder.AttachmentSides = Object.freeze({
    "Left" : "Left", "Right" : "Right", "Both" : "Both"});

SPLM.Features.StructureDesign.StiffenerBuilder.FillTypes = Object.freeze({
    "UppperHalf" : "UppperHalf", "LowerHalf" : "LowerHalf", "Full" : "Full", "MatchedCope" : "MatchedCope"});

SPLM.Features.StructureDesign.StiffenerBuilder.HeightTypes = Object.freeze({
    "Default" : "Default", "Input" : "Input"});

SPLM.Features.StructureDesign.StiffenerBuilder.ThicknessDirs = Object.freeze({
    "Upper" : "Upper", "Lower" : "Lower", "Center" : "Center"});

export default SPLM;